
export default {
  data: () => ({ recentBlogs: [] }),

  async fetch() {
    const { data } = await this.$search.blogSearch({ pageSize: 6 });
    this.recentBlogs = data.results;
  },
};
